import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #00000065;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Content = styled.div`
  background: #ffffff;

  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
  border-radius: 32px;
  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  max-width: 360px;

  > svg {
    stroke-width: 3px;
    background: ${({ theme }) => theme.colors.orange.primary};
    padding: 4px;
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.white};
  }
`;
